import LoadingGif from '~/images/icons/loading.gif';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import { Component } from 'react';
import { observer } from 'mobx-react';

const DonateFormIhoPreview = observer(
  class DonateFormIhoPreview extends Component {
    componentDidMount = () => {
      store.iho.previewLoading = !store.iho.previewLoading;
    };

    render() {
      const {
        amountHidden,
        fromFullName,
        honoreeFullName,
        message,
        recipientFullName,
        sendTo,
        type,
      } = store.iho.honoreeDraft;

      const params = {
        locale: store.donateForm.locale,
        iho: {
          amount_hidden: amountHidden,
          design: store.iho.design.slug,
          from_full_name: fromFullName || 'Someone',
          honoree_full_name: honoreeFullName || 'Someone',
          message: message,
          recipient_full_name: recipientFullName,
          send_to: sendTo,
          type: type,
        },
        donation_form: {
          amount: store.donateForm.amount,
          campaign_id: store.donateForm.campaignId,
        },
      };

      return (
        <div
          className={cx('iho-preview-wrapper', {
            loading: store.iho.previewLoading,
          })}
        >
          <div className='loading-indicator'>
            <img height='64' src={LoadingGif} width='64' />
          </div>
          <div className='iho-preview'>
            <iframe
              id='preview'
              onLoad={() =>
                (store.iho.previewLoading = !store.iho.previewLoading)
              }
              src={`//${window.location.host}/ihos/preview?${$.param(params)}`}
            />
          </div>
          <div className='fade' />
        </div>
      );
    }
  }
);

export default DonateFormIhoPreview;
